// The 2.8.8 version of dropdown.js patched from https://github.com/xamey/Fomantic-UI-LESS/blob/2.9.0-temp
// Downloaded from https://github.com/xamey/Fomantic-UI-LESS/blob/2.9.0-temp/definitions/modules/dropdown.js
import "../vendor/dropdown.js";
import FuiModuleModifier from "./fui-module";

export default class FuiDropdownModifier extends FuiModuleModifier {
  override semanticModuleName = "dropdown";

  /*
  unbind.intent() removes the "click" event listener on "document"

  If the element is removed from the DOM before its FUI module is destroyed,
  document would still listen to "click"

  The Node 20 -> 24 upgrade in PR #11476 revealed this by logging a bunch of
  `Transition: Element is no longer attached to DOM. Unable to animate.  Use silent setting to surpress this warning in production. slide down out [object HTMLDivElement]"}`

  This behaviour MIGHT have been the cause of many FLAKY tests… 🤔
  */
  protected override cleanupBeforeDestroy(): void {
    const unbind = this.semanticModule("unbind") as { intent?: () => void };
    unbind.intent?.();
  }
}
